import { toast } from '@CommonComponents/toast'
import React, { useState, useEffect } from 'react'
import { GoBackLink } from '../GoBackLink'
import { Table } from 'react-bootstrap'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import { LoadingSpinner } from '../../../components'

import { client } from '@Utils'

import { useStateValue } from '@State'


export const ContextMembers = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [getMembersError, setGetMembersError] = useState('')

  const [removeMemberModalShow, toggleRemoveMemberModal] = useState(false)
  const removeMembersMessage = `This will delete all Context Memberships for this Context. Are you sure you wish to proceed?
Note: Course memberships are NOT deleted since a student may purchase our materials but drop the LMS Course independently.
  `
  useEffect(() => {
    const getContext = async () => {
      try {
        let contextCoursesResp = await client.get(
          `/account/admin_lti13.getContextCourses/-/${match.params.issuerId}/${match.params.clientId}/${match.params.deploymentId}/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateContext',
          context: contextCoursesResp.data.context,
        })
      } catch (err) {
        if (err.response) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      }
    }
    getContext()
  }, [currentState.reloadSwitch])

  const updateAllMembers = async () => {
    try {
      const resp = await client.get(`/account/admin_lti13.updateContextMemberIds/${match.params.contextId}/`)
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toast.success(`Updated LTI 1.3 & LTI 1.1 Ids for ${resp.data.users_updated.length} users`)
    } catch (err) {
      toast.error(`${err.response.statusText} ${err.response.data.error}`)
    }
  }

  useEffect(() => {
    const getMembers = async () => {
      try {
        let membersResp = await client.get(
          `/account/admin_lti13.getContextMembers/-/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateMembers',
          members: membersResp.data.members,
        })
      } catch (err) {
        if (err.response) {
          setGetMembersError(err.response.data.error)
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          setGetMembersError(err)
        }
      }
    }
    getMembers()
  }, [currentState.reloadSwitch])

  const getFoundStatus = value => {
    return value === 'True' ? (
      <span style={{ border: 'solid grey 1px' }} className="label label-success">Yes</span>
    ) : (
      <span style={{ border: 'solid grey 1px' }} className="label label-danger">No</span>
    )
  }

  const getCourseStatus = (course) => {
    const style = course[0] === 'True' ? 'label label-success' : 'label label-danger'
    return <span style={{ border: 'solid grey 1px' }} className={style}>{course[1]} </span>
  }

  return (
    <>
      <div className="mb-4">
        <div className="go-back-button-left-align">
          <GoBackLink to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}`} />
        </div>
      </div>
      {currentState.context && (
        <div className="card-myed">
          <h3>Context </h3>
          <div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Id:
              </span>{' '}
              {currentState.context.contextId}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Id:
              </span>{' '}
              {currentState.context.id}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Title:
              </span>{' '}
              {currentState.context.contextTitle}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Label:
              </span>{' '}
              {currentState.context.contextLabel}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                <a
                  onClick={() => toggleRemoveMemberModal(true)}
                  className="btn btn-sm btn-sm-myed btn-danger"
                >
                  Remove All Members <i className="fa-regular fa-window-close" />
                </a>
              </span>
            </p>
          </div>
        </div>
      )}
      {currentState.members.length > 0 ? (
        <div className="card-myed">
          <div className="row">
            <h3 className="col-md-11">Members: </h3>
            <div className="col-md-1 col-md-offset-11">
              <button onClick={updateAllMembers}
                className="btn btn-sm btn-sm-myed btn-default btn-primary"
              >
                Update all LTI Ids
              </button>
            </div>
          </div>
          <div className="table-responsive">
          <Table striped bordered className="table-sm" hover>
            <thead>
              <tr>
                <th>Email</th>
                <th>Last, First</th>
                <th>LMS Context Membership</th>
                <th>Has Launched</th>
                <th>Course Memberships</th>
                <th>LMS Roles</th>
                <th>LTI 1.3 ID</th>
                <th>LTI 1.1 ID</th>
                <th>Support Dashboard</th>
              </tr>
            </thead>
            <tbody>
              {currentState.members.map((mem, i) => (
                <tr key={i}>
                  <td>{mem.email}</td>
                  <td>{mem.last_name}, {mem.first_name}</td>
                  <td>{getFoundStatus(mem.HasLMSContextMembership)}</td>
                  <td>{getFoundStatus(mem.HasLaunched)}</td>
                  <td>
                    {mem.courseMemberships && mem.courseMemberships.map((course, i) => (
                      <div className='m-2' key={i}>{getCourseStatus(course)}</div>
                    ))}
                  </td>
                  <td>{mem.LMSRoles && mem.LMSRoles.map((role) => <div key={`${role}-${mem.email}`}>{role}</div>)}</td>
                  <td>{mem.Lti13Id}</td>
                  <td>{mem.Lti11Id}</td>
                  <td>
                    {mem.MyEducatorId ? (
                      <div className="">
                        <a
                          className="btn btn-sm btn-sm-myed btn-default btn-primary"
                          href={`/account/support_dashboard/-/${mem.MyEducatorId}`}>
                          Go
                        </a>
                      </div>
                    ) : (
                      <span>N/A</span>
                    )
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>
        </div>
      ) : getMembersError ? (
        <div>
          <div className="d-flex justify-content-center">
            <p>{getMembersError}</p>
          </div>
        </div>

      ) : (
        <div>
          <div className="d-flex justify-content-center">
            <p>Pulling Resource Link info from LMS...</p>
          </div>
          <div className="d-flex justify-content-center">
            <LoadingSpinner
              style={{ fontSize: '10em', color: '#004876' }}
              outerClass={'block'}
            />
          </div>
        </div>
      )
      }

      <RemoveConfirmModal
        modalTitle="Remove all Members"
        message={removeMembersMessage}
        endpoint={`/account/admin_lti13.deleteContextMembers/${match.params.contextId}/`}
        show={removeMemberModalShow}
        toggle={toggleRemoveMemberModal}
        currentState={currentState}
        dispatch={dispatch}
      />
    </>
  )
}
